import { useEffect, useState } from 'react';

import { useSetAtom } from 'jotai';
import { env } from 'next-runtime-env';

import type { Locale } from '@core/Entities/Locale/Locale.entity';
import type { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import { fetchJson } from '@core/Utils/Fetch/FetchJson';

import { eligibleProductAtom } from '../../../../Atoms/EligibleProduct.atom';
import { isMatchTypeValue, type ProductDetail } from '../../../../Entities/Product.entity';

export const useDriftrockCheckbox = ({
  vehicle,
  locale,
}: {
  vehicle: Vehicle | null;
  locale: Locale;
}) => {
  const { heycarId } = vehicle ?? {};
  const setEligibleProduct = useSetAtom(eligibleProductAtom);
  const [eP, setEP] = useState<ProductDetail | undefined>(undefined);

  const getEligibility = async () => {
    const data = await fetchJson<{ product: ProductDetail }>(
      `${env('NEXT_PUBLIC_COMMON_API_URL')}/product-offering/eligibility-check/details`,
      {
        headers: {
          'x-heycar-tenant': locale,
        },
        method: 'POST',
        body: JSON.stringify({
          vehicle: vehicle,
          productCodes: vehicle!.eligibleProducts.filter((product: string) =>
            product.includes('DRIFTROCK_'),
          ),
        }),
      },
    );

    if (!data) {
      throw new Error();
    }

    if (data.product && data.product.state === 'MATCHED') {
      setEligibleProduct(data.product);
      setEP(data.product);

      if (!isMatchTypeValue(data.product.matchType)) {
        data.product.matchType = 'DEFAULT';
      }
    }
  };

  useEffect(() => {
    if (heycarId) getEligibility();
  }, [heycarId]);

  return eP;
};
